import { render, staticRenderFns } from "./SupplierArchiveTable.vue?vue&type=template&id=229bac23&scoped=true&"
import script from "./SupplierArchiveTable.vue?vue&type=script&lang=ts&"
export * from "./SupplierArchiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierArchiveTable.vue?vue&type=style&index=0&id=229bac23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229bac23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VDataTable,VDivider,VSpacer,VTextField})
